import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useAuthStore } from '@shared/stores/authStore';

export const useVerifyNewEmail = () => {
  const { toast } = useToast();
  const { t } = useTranslation('usersModule');
  const httpClient = createHttpClient(apiClientWH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => {
      const userId = parseInt((useAuthStore.getState().user as any)?.id || '0');
      return httpClient.post(`/new-mail-verify?token=${encodeURIComponent(token)}&user_id=${userId}`);
    },
    onSuccess: () => {
      toast({
        title: t('verifyNewEmail.success.title', 'Email verificado'),
        description: t('verifyNewEmail.success.description', 'Se cerrará la sesión. Inicia sesión con tu nuevo email.'),
        variant: 'default',
      });

      useAuthStore.getState().logout();
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      queryClient.invalidateQueries({ queryKey: ['me'] });
      queryClient.clear();

      window.location.href = '/login';
    },
    onError: (error: any) => {
      console.error('[verify-new-email] error:', error);

      const errorMessage = t('verifyNewEmail.errors.unexpected', 'Error inesperado al verificar el email');

      toast({
        title: t('verifyNewEmail.errors.title', 'Error al verificar email'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });
};
